var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashfull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 88,
    viewBox: "0 0 86 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20297_68899)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 32,
    height: 34,
    rx: 4,
    fill: "#E3E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 38V45M41 38V45M37 34V45.8C37 46.9201 37 47.4798 37.218 47.9076C37.4097 48.2839 37.7155 48.5905 38.0918 48.7822C38.5192 49 39.079 49 40.1969 49H45.8031C46.921 49 47.48 49 47.9074 48.7822C48.2837 48.5905 48.5905 48.2839 48.7822 47.9076C49 47.4802 49 46.921 49 45.8031V34M37 34H39M37 34H35M39 34H47M39 34C39 33.0681 39 32.6024 39.1522 32.2349C39.3552 31.7448 39.7443 31.3552 40.2344 31.1522C40.6019 31 41.0681 31 42 31H44C44.9319 31 45.3978 31 45.7654 31.1522C46.2554 31.3552 46.6447 31.7448 46.8477 32.2349C46.9999 32.6024 47 33.0681 47 34M47 34H49M49 34H51",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20297_68899",
    x: 0,
    y: 0,
    width: 86,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20297_68899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20297_68899",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashfull);
export default __webpack_public_path__ + "static/media/trashfull.82d24442edc2f9fca53b364316d74117.svg";
export { ForwardRef as ReactComponent };